import api from './api';
import { jwtDecode } from 'jwt-decode';

const AUTH_TOKEN_KEY = 'token';

// Login user and store token
const login = async (email, password) => {
  try {
    const response = await api.post('/public-api/v1/authentication/login', {
      email,
      password
    });
    
    if (response.data && response.data.token) {
      localStorage.setItem(AUTH_TOKEN_KEY, response.data.token);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Logout user and remove token
const logout = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  window.location.href = '/login';
};

// Check if user is authenticated
const isAuthenticated = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) return false;
  
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    
    // Check if token is expired
    if (decoded.exp && decoded.exp < currentTime) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Token validation error:', error);
    localStorage.removeItem(AUTH_TOKEN_KEY);
    return false;
  }
};

// Get current user info from token
const getCurrentUser = () => {
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) {
      return jwtDecode(token);
    }
    return null;
  } catch (error) {
    console.error('Get user error:', error);
    return null;
  }
};

// Get auth token
const getToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

const AuthService = {
  login,
  logout,
  isAuthenticated,
  getCurrentUser,
  getToken
};

export default AuthService;